module.exports = __webpack_public_path__ + "media/images/icons/outlined/area-chart-a48c43780b0e4c96bfca862b07da99f6.svg";